
// import React from "react";
// import { useEffect, useState } from "react";
// import { useFormik } from "formik";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import axios from "../../../../../../Services/axiosCommon";
// import {
//   BackButton,
//   CancelButton,
//   SubmitButton,
// } from "../../../../../../Components/Utils/Buttons";
// import Dasboard from "../../../../../../Components/Icons/Dasboard";
// import * as yup from "yup";
// import { notification } from "antd";
// import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
// import UseDropDown from "../../../../../../Components/Hooks/useDropDown";
// import Breadcrumb from "../../../../../../Components/Utils/Breadcrumb";
// import { NuInput, NuLabel, NuSelect, NuTextArea } from "../../../../../../Components/Utils/Input";
// import FormikSelectTwo from "../../../../../../Components/Utils/Select";



// export default function CreateMaterial({ data }) {
//   const navigate = useNavigate();
//   const {officeId,projectId} = useParams();
//   // const {value:Category} = useFetchMataData(`/Metadata/category`)
//   // const {value:Unit} = useFetchMataData(`/Metadata/unit`)
//   // const {value:Division} = useFetchMataData(`/Metadata/division`)
//   // const { data: Item } = UseDropDown('/Activity/drop-down');
//   const {value:Category ,getData:refMatrialCategory} = useFetchMataData(`/dropdown/dropdown-details/`,'MatrialCategory')
//   const {value:Division ,getData:refMatrialDivision} = useFetchMataData(`/dropdown/dropdown-details/`,'MatrialDivision')
//   const {value:Item ,getData:refMatrialItem} = useFetchMataData(`/dropdown/dropdown-details/`,'MatrialItem')
//   const {value:Unit ,getData:refMaterialUnit} = useFetchMataData(`/dropdown/dropdown-details/`,'MaterialUnit')

//   const [api, contextHolder] = notification.useNotification();
//   // const [projectList,setProjectList] =useState([])
//   const [isLoading, setIsLoading] = useState(false);
//   const [createNew, setCreateNew] = useState({
//     projectId:"",
//     item:"",
//     category:"",
//     division:"",
//     unit:"",
//     quantity:"",
//     amount:"",
//     comments:"",
//     type:""
//   });

//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues: createNew,
//     validateOnChange: false,
//     validateOnBlur: true,
//     validationSchema: yup.object({
//       item: yup.string().required("Item is Required"),
//       quantity: yup.string().required("Quantity is Required"),
//     }),
//     onSubmit: async (value) => {
//       setIsLoading(true);
//       value.projectId = projectId
//       data
//         ? axios
//             .put(`/material/${data?.id}`, value)
//             .then((res) => {
//               if (res.status == 201 || res.data.status == true) {
//                 setIsLoading(false);
//                 api.success({
//                   message: `Add successfully`,
//                   description: res?.data?.msg || " created",
//                   placement: "bottomRight",
//                 });
//                 navigate(-1);
//               } else {
//                 setIsLoading(false);
//                 api.error({
//                   message: `Unsuccessfully`,
//                   description: res?.data?.msg || "creation failed",
//                   placement: "bottomRight",
//                 });
//               }
//             })
//             .catch((err) => {
//               setIsLoading(false);
//               api.error({
//                 message: `Unsuccessfully`,
//                 description: err?.response?.data?.msg || "creation failed",
//                 placement: "bottomRight",
//               });
//             })
//         : axios
//             .post("/material/", value)
//             .then((res) => {
//               if (res.status == 201 || res.data.status == true) {
//                 setIsLoading(false);
//                 api.success({
//                   message: `Add successfully`,
//                   description: res?.data?.msg || " created",
//                   placement: "bottomRight",
//                 });
//                 navigate(-1);
//               } else {
//                 setIsLoading(false);
//                 api.error({
//                   message: `Unsuccessfully`,
//                   description: res?.data?.msg || "creation failed",
//                   placement: "bottomRight",
//                 });
//               }
//             })
//             .catch((err) => {
//               setIsLoading(false);
//               api.error({
//                 message: `Unsuccessfully`,
//                 description: err?.response?.data?.msg || "creation failed",
//                 placement: "bottomRight",
//               });
//             });
//     },
//   });


//   // async function getProject() {
//   //   await axios
//   //     .get(`/Team/getUserProjectId`)
//   //     .then(async (res) => {

//   //       let list = res?.data?.data || [];
//   //       let finalData = [];
//   //       (await res?.data?.data) &&
//   //         list.map((item, idx) => {
//   //           finalData.push({
//   //             value: item.ProjectId,
//   //             label: item.ProjectName,
//   //           });
//   //         });
//   //       setProjectList(finalData);
//   //     })
//   //     .catch((error) => {
//   //       console.log(error);
//   //     });
//   // }
//   const [activity,setActivity] =useState([])

//   async function getActivity() {
//     await axios
//       .get(`/Activity/${officeId}/drop-down`)
//       .then(async (res) => {

//         let list = res?.data?.data || [];
//         let finalData = [];
//         (await res?.data?.data) &&
//           list.map((item, idx) => {
//             finalData.push({
//               value: item.value,
//               label: item.label,
//             });
//           });
//           setActivity(finalData);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   }

//   useEffect(() => {
//     // getProject()
//     getActivity()
//   },[])

//   return (
//     <div className="w-full mx-auto py-2 px-4 ">
//       {contextHolder}
//       <div className="md:flex justify-between w-full">
//       <Breadcrumb 
//       items={[

//         { name: "Budget" },
           
//         {
//           name: "Material",
//           link: `/project/costing/material/${officeId}/${projectId}`
//         },

//         { name: "Create" },
//       ]} 
//             />
//         {/* <Breadcrumb
//           items={[
//             {
//               title: (
//                 <Link to="/dashboard">
//                   <Dasboard color="gray" width={10} height={10} />{" "}
//                 </Link>
//               ),
//             },
//             {
//               title: (
//                 <Link to="#">
//                   <p className=" text-[12px] ">Budget</p>
//                 </Link>
//               ),
//             },
//             {
//               title: (
//                 <Link to="/costing/material">
//                   <p className=" text-[12px] ">Material</p>
//                 </Link>
//               ),
//             },
//             { title: <p className=" text-[12px] ">Create</p> },
//           ]}
//         /> */}

//         <div className=" flex gap-2 items-center mr-6">
//           <BackButton />
//         </div>
//       </div>
//       <div>
//         <div
//           className=" w-full mx-auto h-[85%] bg-white rounded-[6px] mt-2"
//           // style={{ border: "1px solid #C5C5C5" }}
//         >
//           <form onSubmit={formik.handleSubmit}>
//             <div className=" w-full flex justify-between items-center">
//               <NuLabel label="Material" />
//               {/* <BackButton /> */}
//             </div>
//             <div className="flex flex-wrap justify-start">

//                 {/* <NuSelect
//                   label="Project"
//                   options={projectList||[]}
//                   formik={formik}
//                   placeholder="Choose"
//                   name="projectId"
//                   width="w-full md:w-1/3"
//                   isRequired={true}
//                 /> */}
//  <FormikSelectTwo
//                   label="Item"
//                   Options={Item||[]}
//                   formik={formik}
//                   placeholder="Choose"
//                   name="item"
//                   width="w-full md:w-1/3"
//                   getFunc={refMatrialItem}
//                   displayProperty={"Item"}
//                   propertyName={"MatrialItem"}
//                   isRequired={true}
//                 />
//               {/* <NuInputText
//                  label="Item"
//                  formik={formik}
//                  placeholder="Item"
//                  name="item"
//                  width="w-full md:w-1/3"
//                  isRequired={true}
//                 />  */}

//                 <FormikSelectTwo
//                   label="Division"
//                   Options={Division||[]}
//                   formik={formik}
//                   placeholder="Choose"
//                   getFunc={refMatrialDivision}
//                   displayProperty={"Division"}
//                   propertyName={"MatrialDivision"}
//                   name="division"
//                   width="w-full md:w-1/3"
//                   isRequired={true}
//                 />

//                 <FormikSelectTwo
//                   label="Category"
//                   Options={Category||[]}
//                   formik={formik}
//                   placeholder="Choose"
//                   name="category"
//                   width="w-full md:w-1/3"
//                   isRequired={true}
//                   getFunc={refMatrialCategory}
//                   displayProperty={"Category"}
//                   propertyName={"MatrialCategory"}
//                 />

//                 <FormikSelectTwo
//                   label="Unit"
//                   Options={Unit||[]}
//                   formik={formik}
//                   placeholder="Choose"
//                   name="unit"
//                   width="w-full md:w-1/3"
//                   isRequired={true}
//                   getFunc={refMaterialUnit}
//                   displayProperty={"Unit"}
//                   propertyName={"MaterialUnit"}
//                 />
 
//                 <NuInput
//                              type="number"

//                  label="Quantity"
//                  formik={formik}
//                  placeholder="Quantity"
//                  name="quantity"
//                  width="w-full md:w-1/3"
//                  isRequired={true}
//                 />     

//                 <NuInput
//                              type="number"

//                  label="Amount"
//                  formik={formik}
//                  placeholder="Amount"
//                  name="amount"
//                  width="w-full md:w-1/3"
//                  isRequired={true}
//                 />   

//                 <NuTextArea
//                   label="Comments"
//                   placeholder="Comments"
//                   formik={formik}
//                   name="comments"
//                   width="w-full md:w-2/3"
//                 />



//             </div>
//             <div className="flex justify-between items-center">
//               <div className="w-1/2">

//               </div>

//               <div
//                 className=" mr-2 rounded-md"
//                 style={{ border: "1px solid #C5C5C5" }}
//               >

//               </div>
//               <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
//               <CancelButton handleClick={() => navigate(-1)} />
//               <SubmitButton isLoading={isLoading} />
//             </div>
//             </div>

            
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }// import React from "react";
// import { useEffect, useState } from "react";
// import { useFormik } from "formik";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import axios from "../../../../../../Services/axiosCommon";
// import {
//   BackButton,
//   CancelButton,
//   SubmitButton,
// } from "../../../../../../Components/Utils/Buttons";
// // import Attachement from "./Attachement";
// import Dasboard from "../../../../../../Components/Icons/Dasboard";
// import * as yup from "yup";
// import { notification } from "antd";
// import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
// import Breadcrumb from "../../../../../../Components/Utils/Breadcrumb";
// import { NuInput, NuLabel, NuSelect, NuTextArea } from "../../../../../../Components/Utils/Input";
// import FormikSelectTwo from "../../../../../../Components/Utils/Select";



// export default function CreateManPower({ data }) {
//   const {projectId,officeId} = useParams();
//   // const {value:Designation} = useFetchMataData(`/Metadata/clientPosition`)
//   // const {value:Category} = useFetchMataData(`/Metadata/category`)
//   const {value:Category ,getData:refManPowerCategory} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerCategory')
//   const {value:Designation ,getData:refManPowerDesignation} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerDesignation')
//   const {value:Type ,getData:refManPowerType} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerType')

//   const navigate = useNavigate();
//   const [api, contextHolder] = notification.useNotification();
//   const [projectList,setProjectList] =useState([])
//   const [isLoading, setIsLoading] = useState(false);
//   const [createNew, setCreateNew] = useState({
//     projectId:"",
//     designation:"",
//     category:"",
//     type:"",
//     quantity:"",
//     noOfDays:"",
//     hours:"",
//     comments:""
//   });

//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues: createNew,
//     validateOnChange: false,
//     validateOnBlur: true,
//     validationSchema: yup.object({
//       designation: yup.string().required("Designation is Required"),
//       quantity: yup.string().required("Quantity is Required"),
//     }),
//     onSubmit: async (value) => {
//       setIsLoading(true);
//       value.projectId = projectId;
//       data
//         ? axios
//             .put(`/man_power_cost/${data?.id}`, value)
//             .then((res) => {
//               if (res.data.status == true) {
//                 setIsLoading(false);
//                 api.success({
//                   message: `Add successfully`,
//                   description: res?.data?.msg || " created",
//                   placement: "bottomRight",
//                 });
//                 navigate(-1);
//               } else {
//                 setIsLoading(false);
//                 api.error({
//                   message: `Unsuccessfully`,
//                   description: res?.data?.msg || "creation failed",
//                   placement: "bottomRight",
//                 });
//               }
//             })
//             .catch((err) => {
//               setIsLoading(false);
//               api.error({
//                 message: `Unsuccessfully`,
//                 description: err?.response?.data?.msg || "creation failed",
//                 placement: "bottomRight",
//               });
//             })
//         : axios
//             .post("/man_power_cost/", value)
//             .then((res) => {
//               if (res.status == 201 || res.data.status == true) {
//                 setIsLoading(false);
//                 api.success({
//                   message: `Add successfully`,
//                   description: res?.data?.msg || " created",
//                   placement: "bottomRight",
//                 });
//                 navigate(-1);
//               } else {
//                 setIsLoading(false);
//                 api.error({
//                   message: `Unsuccessfully`,
//                   description: res?.data?.msg || "creation failed",
//                   placement: "bottomRight",
//                 });
//               }
//             })
//             .catch((err) => {
//               setIsLoading(false);
//               api.error({
//                 message: `Unsuccessfully`,
//                 description: err?.response?.data?.msg || "creation failed",
//                 placement: "bottomRight",
//               });
//             });
//     },
//   });


//   // async function getProject() {
//   //   await axios
//   //     .get(`/Team/getUserProjectId`)
//   //     .then(async (res) => {

//   //       let list = res?.data?.data || [];
//   //       let finalData = [];
//   //       (await res?.data?.data) &&
//   //         list.map((item, idx) => {
//   //           finalData.push({
//   //             value: item.ProjectId,
//   //             label: item.ProjectName,
//   //           });
//   //         });
//   //       setProjectList(finalData);

//   //       // await res?.data?.Project && setTotalProject(res?.data?.totalProject);
//   //       // console.log('====',res?.data?.data);
//   //     })
//   //     .catch((error) => {
//   //       console.log(error);
//   //     });
//   // }

//   // useEffect(() => {
//   //   getProject()
//   // },[])

//   return (
//     <div className="w-full mx-auto py-2 px-4 ">
//       {contextHolder}
//       <div className="md:flex justify-between w-full">
//       <Breadcrumb items={[
               
//                 {
//                     name:"Manpower",
//                     link:`/project/costing/man-power/${officeId}/${projectId}`
//                 },
//                 {
//                   name:"Create"
//               },
//             ]} />


//         <div className=" flex gap-2 items-center mr-6">
//           <BackButton />
//         </div>
//       </div>
//       <div>
//         <div
//           className=" w-full mx-auto h-[85%] bg-white rounded-[6px] mt-2"
//           // style={{ border: "1px solid #C5C5C5" }}
//         >
//           <form onSubmit={formik.handleSubmit}>
//             <div className=" w-full flex justify-between items-center">
//               <NuLabel label="Manpower" />
//               {/* <BackButton /> */}
//             </div>
//             <div className="flex flex-wrap justify-start">

//                 {/* <NuSelect
//                   label="Project"
//                   options={projectList||[]}
//                   formik={formik}
//                   placeholder="Choose"
//                   name="projectId"
//                   width="w-full md:w-1/3"
//                   isRequired={true}
//                 /> */}
//                 <FormikSelectTwo
//                   label="Designation"
//                   Options={Designation||[]}
//                   formik={formik}
//                   placeholder="Choose"
//                   name="designation"
//                   width="w-full md:w-1/3"
//                   getFunc={refManPowerDesignation}
//                 displayProperty={"Designation"}
//                 propertyName={"ManPowerDesignation"}
//                   isRequired={true}
//                 />
//                 <FormikSelectTwo
//                   label="Category"
//                   Options={Category}
//                   formik={formik}
//                   placeholder="Choose"
//                   name="category"
//                   width="w-full md:w-1/3"
//                   getFunc={refManPowerCategory}
//                 displayProperty={"Category"}
//                 propertyName={"ManPowerCategory"}
//                   isRequired={true}
//                 />
//                 <FormikSelectTwo
//                   label="Type"
//                   Options={Type}
//                   formik={formik}
//                   placeholder="Choose"
//                   name="type"
//                   width="w-full md:w-1/3"
//                   getFunc={refManPowerType}
//                 displayProperty={"Type"}
//                 propertyName={"ManPowerType"}
//                   isRequired={true}
//                 />
//                 <NuInput
//                              type="number"

//                  label="No. of Workers"
//                  formik={formik}
//                  placeholder="No. of Workers"
//                  name="quantity"
//                  width="w-full md:w-1/3"
//                  isRequired={true}
//                 />
//                 <NuInput
//                              type="number"

//                  label="No. Of Days"
//                  formik={formik}
//                  placeholder="No. Of Days"
//                  name="noOfDays"
//                  width="w-full md:w-1/3"
//                  isRequired={true}
//                 />      
//                 <NuInput
//                              type="number"

//                  label="Total Hours"
//                  formik={formik}
//                  placeholder="Total Hours"
//                  name="hours"
//                  width="w-full md:w-1/3"
//                  isRequired={true}
//                 />  
//                 <NuTextArea
//                   label="Comments"
//                   placeholder="Comments"
//                   formik={formik}
//                   name="comments"
//                   width="w-full md:w-2/3"
//                 />



//             </div>
//             <div className="flex justify-between items-center">
//               <div className="w-1/2">

//               </div>

//               <div
//                 className=" mr-2 rounded-md"
//                 style={{ border: "1px solid #C5C5C5" }}
//               >

//               </div>
//               <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
//               <CancelButton handleClick={() => navigate(-1)} />
//               <SubmitButton isLoading={isLoading} />
//             </div>
//             </div>

           
//           </form>
         
//         </div>
        
//       </div>
//     </div>
//   );
// }

import React, { useState } from 'react'
import { LongButton } from '../../../../../../Components/Utils/Buttons';
import { NuInput } from '../../../../../../Components/Utils/Input';
import { Modal, notification } from 'antd';
import axiosInstance from '../../../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import { useParams } from 'react-router-dom';
import * as yup from 'yup';

function CreateMaterial({open,onCancel,getData}) {
  const { projectId } = useParams();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading,setIsLoading] = useState(false);
  const [createNew, setCreateNew] = useState({
    name: "",
    projectId: projectId,
    type: 1,
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema:yup.object({
      name:yup.string().trim() // Removes whitespace from both ends
      .min(1, "Title cannot be empty or just spaces").required("Tittle is Requried").required("Tittle is Requried")
    }),
    onSubmit: (value,{resetForm}) => {    
      setIsLoading(true);
      axiosInstance
      .post("/budget-title/create", value)
        .then((res) => {
          console.log(res);
          if (res.status === 201 || res.data.status == true) {
            getData();
            resetForm();
            setIsLoading(false);
            api.success({
              message: `Tittle Creation successfully`,
              description: res?.data?.msg || "Added In Tittle",
              placement: "bottomRight",
            });
            onCancel();
          } else {
            setIsLoading(false);
            api.error({
              message: `Tittle Creation failed`,
              description: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          setIsLoading(false);
          api.error({
            message: `Tittle Creation failed`,
            description: err?.data?.msg || "Sever error (or) Network error",
            placement: "bottomRight",
          });
        });
    },
  });
  return (
    <>
    {contextHolder}
    <Modal
      open={open}
      title={"Create Material Title"}
      width={"50%"}
      className="my-modal"
      centered
      footer={[]}
      onCancel={onCancel}
    >
    <form onSubmit={formik.handleSubmit} >
      <div className=" w-full flex flex-wrap">
         <NuInput
                      type="text"

              label="Tittle"
              placeholder="Tittle"
              formik={formik}
              name="name"
              width="w-full"
          />
          <LongButton isLoading={isLoading} />
      </div>
      </form>
    </Modal>
    </>
  )
}


export default CreateMaterial